import { Injectable } from '@angular/core';
import { CommonConstants } from '@coreConstant';
import { RequestParamModel } from '@coreModels';
import { format } from 'date-fns';
import { lastValueFrom } from 'rxjs';
import { QuoteOrdersService } from './quote-orders.service';
import { SubscribersService } from '../subscribers.service';
import { ToastService } from '../toast.service';

@Injectable({
  providedIn: 'root'
})
export class SampleOrderService {

  constructor(private quoteOrdersService: QuoteOrdersService, private subscriberService: SubscribersService, private toastService: ToastService) { }

  async getSampleOrders(userId: any, showError: boolean = false, isRequestFromHeader: boolean = false) {
    let requestParamModelSampleOrder = new RequestParamModel();
    requestParamModelSampleOrder.addDefaultFilters('type', CommonConstants.QUOTE_TYPE_SAMPLE_ORDER, 'number');
    requestParamModelSampleOrder.addDefaultFilters('frontend_user_id', userId, 'number');
    requestParamModelSampleOrder.addDefaultFilters('created_at', format(new Date(), 'yyyy-MM-dd'), 'date');
    requestParamModelSampleOrder.addDefaultFilters('is_deleted', false, 'number');
    requestParamModelSampleOrder.pageSize = 1;
    requestParamModelSampleOrder.sortChange('id', 'desc');

    await lastValueFrom(this.quoteOrdersService.getQuoteOrders(requestParamModelSampleOrder)).then(async (res: any) => {
      if (res?.totalCount != 0) {
        this.subscriberService.sampleOrderError.set(true);
        if (showError) this.toastService.showError(CommonConstants.SAMPLE_ORDER_ITEM_LIMIT_ERROR);
      }
    }).catch((error) => {
      if(!isRequestFromHeader) this.toastService.showError(error?.error?.data?.message);
      return { error: error };
    })
  }
}
